
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { PERMISSION } from '@/permissions';
import IconButton from '@/components/shared/suites/IconButton.vue';

@Component<SuitesHeader>({
	components: {
		IconButton
	}
})
export default class SuitesHeader extends Vue {
	@Action('toggleMobileNav', { namespace: 'ui' }) private toggleMobileNav!: (isOpen: boolean) => void;
	@Getter('hasPermission', { namespace: 'auth' }) private hasPermission!: (permission: PERMISSION) => boolean;
	@Prop({ type: String, required: true, default: '' }) private title!: string;
	@Prop({ type: String, required: false, default: '' }) private subtitle!: string;
	@Prop({ type: Array, required: false, default: () => [] }) private breadcrumbs!: { text: string; to: string; }[];
	@Prop({ type: Boolean, required: false, default: false }) private showBackButton!: boolean;

	private PERMISSION = PERMISSION;
}
